// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1HTdm","infoBtn":"quickbooks_infoBtn__1LLoj","formBox":"quickbooks_formBox__2Jp6D","formFooter":"quickbooks_formFooter__2l1fq"};